package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.SegaSimpleIcons: ImageVector
    get() {
        if (_segaSimpleIcons != null) {
            return _segaSimpleIcons!!
        }
        _segaSimpleIcons = Builder(name = "SegaSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(21.23f, 4.14f)
                lineToRelative(-0.01f, 3.33f)
                horizontalLineToRelative(-10.6f)
                curveToRelative(-0.22f, 0.0f, -0.40f, 0.18f, -0.40f, 0.40f)
                curveToRelative(0.0f, 0.22f, 0.18f, 0.40f, 0.40f, 0.40f)
                lineToRelative(2.76f, -0.02f)
                curveToRelative(4.35f, 0.0f, 7.87f, 3.53f, 7.87f, 7.87f)
                curveToRelative(0.0f, 4.35f, -3.52f, 7.87f, -7.87f, 7.87f)
                lineTo(2.75f, 24.0f)
                lineToRelative(0.01f, -3.38f)
                horizontalLineToRelative(10.64f)
                curveToRelative(2.49f, 0.0f, 4.50f, -2.02f, 4.50f, -4.50f)
                curveToRelative(0.0f, -2.49f, -2.02f, -4.51f, -4.51f, -4.51f)
                lineToRelative(-2.77f, -0.03f)
                curveToRelative(-2.06f, 0.0f, -3.73f, -1.67f, -3.73f, -3.72f)
                curveToRelative(0.0f, -2.06f, 1.67f, -3.73f, 3.72f, -3.73f)
                horizontalLineToRelative(10.62f)
                close()
                moveTo(2.76f, 19.84f)
                lineToRelative(-0.00f, -3.33f)
                horizontalLineToRelative(10.61f)
                curveToRelative(0.21f, 0.0f, 0.38f, -0.18f, 0.38f, -0.39f)
                curveToRelative(0.0f, -0.21f, -0.17f, -0.39f, -0.38f, -0.39f)
                horizontalLineToRelative(-2.74f)
                curveToRelative(-4.35f, 0.0f, -7.87f, -3.53f, -7.87f, -7.87f)
                reflectiveCurveTo(6.28f, 0.0f, 10.62f, 0.0f)
                lineToRelative(10.6f, 0.00f)
                lineToRelative(0.01f, 3.35f)
                lineToRelative(-10.60f, 0.00f)
                curveToRelative(-2.49f, 0.0f, -4.5f, 2.02f, -4.5f, 4.51f)
                curveToRelative(0.0f, 2.49f, 2.02f, 4.50f, 4.52f, 4.50f)
                lineToRelative(2.78f, 0.03f)
                curveToRelative(2.06f, 0.0f, 3.72f, 1.67f, 3.72f, 3.72f)
                curveToRelative(0.0f, 2.06f, -1.67f, 3.72f, -3.72f, 3.72f)
                horizontalLineTo(2.77f)
                lineToRelative(-0.00f, 0.00f)
                close()
            }
        }
        .build()
        return _segaSimpleIcons!!
    }

private var _segaSimpleIcons: ImageVector? = null
